import {
  CARD__ACCESS_DENIED,
  CARD__GRANTED_ACCESS_TO_CARD,
  CARD__LOAD_FINISHED,
  CARD__NOTEBOOK_LOADED,
  CARD__RESET_STATE,
  CARD__SAVE_FINISHED,
  CARD__STATISTICS_LOADED,
} from 'app/AppConstants';
import {
  fetchById,
  fetchStatistics,
  grantAccessToCard,
  saveAs,
  fetchNotebookCard,
} from './cardService';
import mapValues from 'lodash/mapValues';
import {selectCardById} from './cardSelectors';
import {buffer} from 'utilities/actionCreatorUtilities';
import {analyticsTrack} from 'utilities/analytics';
import {ADOBE_ANALYTICS_EVENTS} from 'app/Analytics';
import {loadCardSettings} from 'state/cardSetting/cardSettingActions';

export const loadById = id => (dispatch, getState) => {
  if (selectCardById(getState(), id)) return Promise.resolve();
  return fetchById(id).then(response => {
    if (response.length === 0) {
      dispatch({
        type: CARD__ACCESS_DENIED,
        payload: {id},
      });
    } else {
      dispatch({
        type: CARD__LOAD_FINISHED,
        payload: {
          id,
          card: response[0],
        },
      });
    }
  });
};

export const loadPublicEmbedCardById = cardId => dispatch =>
  dispatch(loadById(cardId)).then(() => dispatch(loadCardSettings(cardId)));

export const grantAccessByCardId = (cardId, userIds, groupIds) => {
  return dispatch => {
    const success = () => {
      dispatch({
        type: CARD__GRANTED_ACCESS_TO_CARD,
        payload: {
          id: cardId,
          userIds,
          groupIds,
        },
      });
    };

    // jQuery rejects empty response bodys, even if they are 200
    return grantAccessToCard(cardId, userIds, groupIds).then(success, success);
  };
};

export const loadStatistics = buffer((args, dispatch) => {
  const cardIds = args.map(([cardId]) => cardId);
  const incrementViewCount = args.every(([, increment]) => increment);
  const includeUsers = args.every(([, , users]) => users);

  return fetchStatistics(cardIds, {
    incrementViewCount,
    includeUsers,
  }).then(response =>
    dispatch({
      type: CARD__STATISTICS_LOADED,
      payload: {
        statistics: mapValues(response, stats => ({
          ...stats,
          views: stats.viewCountsV2,
        })),
      },
    })
  );
});

export const saveChartAs = (cardId, options) => (dispatch, getState) => {
  analyticsTrack(ADOBE_ANALYTICS_EVENTS.CARD__DETAILS_SAVE_AS, {
    cardId,
    pageId: options.pageId,
  });

  return saveAs(cardId, options).then(response =>
    dispatch(loadById(response.urn)).then(() =>
      dispatch({
        type: CARD__SAVE_FINISHED,
        payload: {
          card: selectCardById(getState(), response.urn),
          pageId: options.pageId,
        },
      })
    )
  );
};

export const resetCardState = cardId => ({
  type: CARD__RESET_STATE,
  payload: {cardId},
});

export const loadNotebookCard = (id, options = {}) => dispatch =>
  fetchNotebookCard(id, options).then(response =>
    dispatch({
      type: CARD__NOTEBOOK_LOADED,
      payload: {
        id,
        notebook: response,
      },
    })
  );
